module.exports = __webpack_public_path__ + "static/img/home_fn_content_01.0da20a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_01.png
// module id = 1B6g
// module chunks = 34